
// Amber "this person already has an upcoming consultation" notice for the admin
// scheduler (issue #576). Shown for a returning primary/attendee whose Acuity
// lookup found a future appointment, so the admin doesn't book a duplicate.
import { COPY } from './copy'

export default {
    props: {
        // Soonest upcoming appointment for this person, or null. Shape from
        // /appointments/upcoming/: { id, datetime, type, calendar, manage_url }.
        appt: { type: Object, default: null },
    },
    data () {
        return { COPY }
    },
    computed: {
        whenLabel () {
            if (!this.appt || !this.appt.datetime) return ''
            // parseZone keeps Acuity's stored offset so the time reads as the
            // client booked it, not shifted into the admin's browser zone.
            const m = this.$moment.parseZone
                ? this.$moment.parseZone(this.appt.datetime)
                : this.$moment(this.appt.datetime)
            return m.format('dddd, MMMM D [at] h:mm A')
        },
    },
}
